import { Grid } from "@material-ui/core";
import * as React from "react";
import EightWingsStorageSelectInputs from "../../../../../Components/EightWingsComponents/EightWingsStorageSelectInputs";
import { Form } from "react-final-form";
import { SectionTitle } from "../../../../../Components/SectionTitle";
import { useAppDataProvider } from "../../../../../dataprovider";

export const AarStorageSelectForm = props => {
  const [loading, setLoading] = React.useState(false);
  var dataProvider = useAppDataProvider();
  const formRef = React.useRef<any>(null);
  React.useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    dataProvider
      .getList("EightWingsStorageInfoMappeds", {
        pagination: { page: 1, perPage: 9999 },
        sort: { field: "CreatedDate", order: "DESC" },
        filter: { eightWingId__eq: props.eightWingsId },
      })
      .then(response => {
        let data = response.data;
        if (data.length > 0) {
          var lastData = response.data[0];
          if (formRef.current) {
            formRef.current.change("storage", lastData.storage);
            formRef.current.change("pn", lastData.pn);
            formRef.current.change("sn", lastData.sn);
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <>
      {" "}
      <Form
        onSubmit={() => {}}
        render={({ form }) => {
          formRef.current = form;
          return (
            <form>
              <Grid {...props.gridContainerProps}>
                <SectionTitle label="Send To Eight Wings" />
              </Grid>
              <Grid {...props.gridContainerProps} alignItems={"flex-start"}>
                <Grid item xs={12} sm={8}>
                  <EightWingsStorageSelectInputs
                    readonly={true}
                    isUpdate={true}
                    form={form}
                    requirementCategoryList={props?.selectedData?.requirementCategoryList}
                    selectedRequirementCategory={props?.selectedData?.requirementCategory}
                  />
                </Grid>
              </Grid>
            </form>
          );
        }}
      />
    </>
  );
};

export default AarStorageSelectForm;
